import React from 'react';
import { TicketKey } from 'flow/types/EntityKeys';

import StatusChip from './StatusChip';
import AssigneeChip from './AssigneeChip';
import TagChips from './TagChips';

type Props = {
    ticketKey: TicketKey;
    isSelected: boolean;
    muted?: boolean;
};

// The row hides the tags that do not fit. The Status and Assignee chips are
// menu buttons, so the row reaches 4px into the list item's padding at the
// start and bottom, and pads itself by as much: their focus ring then fits
// inside it, and the chips stay where they were.
const SectionChips = ({ ticketKey, isSelected, muted }: Props) => (
    <div className="-ms-1 -mb-1 flex h-9 flex-nowrap items-end gap-1 overflow-hidden ps-1 pb-1">
        <StatusChip ticketKey={ticketKey} isSelected={isSelected} />
        <AssigneeChip
            ticketKey={ticketKey}
            isSelected={isSelected}
            muted={muted}
        />
        <TagChips ticketKey={ticketKey} isSelected={isSelected} muted={muted} />
    </div>
);

export default React.memo(SectionChips);
